import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { ResetDefaultColor } from "../schema/ResetDefaultColorSchema";
import { ResetDefaultColorResponse } from "../response/ResetDefaultColorResponse";

export const useResetDefaultColor = () => {
    return useMutation({
        mutationFn: async (formData: ResetDefaultColor) => await privateApi.post(`/v3/ota-reset-default`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = ResetDefaultColorResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid ota data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to reset ota color', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid ota data format");
            } else {
                console.error(`Failed to reset ota data`, error);
                throw error;
            }
        }
    });
};